/** CSS custom properties for instant theme paint (before React hydrates). */
export const THEME_CSS = {
  dark: {
    bg: '#000000',
    text: '#f5f5f7',
    surface: '#1d1d1f',
    elevated: '#2c2c2e',
    accent: '#2c2c2e',
    label: '#98989d',
    skill: '#a1a1a6',
    'card-border': '1px solid rgba(255, 255, 255, 0.08)',
    'nav-surface': 'rgba(44, 44, 46, 0.96)',
    'hero-blob-blue': 'rgba(72, 130, 255, 0.38)',
    'hero-blob-violet': 'rgba(160, 100, 255, 0.32)',
    'hero-blob-rose': 'rgba(255, 120, 180, 0.26)',
    'hero-blob-mint': 'rgba(80, 220, 200, 0.22)',
  },
  light: {
    bg: '#f5f5f7',
    text: '#1d1d1f',
    surface: '#ffffff',
    elevated: '#ffffff',
    accent: '#e8e8ed',
    label: '#48484a',
    skill: '#48484a',
    'card-border': '1px solid rgba(0, 0, 0, 0.06)',
    'nav-surface': 'rgba(232, 232, 237, 0.96)',
    'hero-blob-blue': 'rgba(150, 200, 255, 0.58)',
    'hero-blob-violet': 'rgba(210, 170, 255, 0.52)',
    'hero-blob-rose': 'rgba(255, 190, 220, 0.48)',
    'hero-blob-mint': 'rgba(170, 240, 220, 0.44)',
  },
};

export const themeVar = (name, fallback) => `var(--theme-${name}, ${fallback})`;

/** Styled-components helper – prefers CSS var so data-theme switches instantly. */
export const themed = (name, themeKey) => p =>
  themeVar(name, p.theme[themeKey]);
